import React from "react";
import { FluentDatePicker } from "../../FluentUI/Fluent-DatePicker";
import TableDatePicker from "./StyledDatepicker/table-datepicker";

import "./datepicker-wrapper.styles.scss";

const DatePickerWrapper = ({ chosenDate, setChosenDate, onChange, filterType, removeFilter }) => {
  return (
    <div className="calendar-wrapper">
      <div className="calendar-first-row">
        <div>
          <p className="calendar-title">{filterType}:</p>
          <FluentDatePicker
            disabled
            className="calendar-text-box"
            value={chosenDate}
            onChange={(date) => setChosenDate(date)}
            placeholder="MM/DD/YYYY"
          />
        </div>
      </div>
      <div className="calendar-second-row">
        <TableDatePicker
          selectedDate={chosenDate}
          setSelectedDate={(date) => setChosenDate(date)}
          onChange={onChange}
        />
      </div>

      <div className="calendar-bottombar">
        <button
          className="calendar-clear-button"
          onClick={() => {
            setChosenDate(undefined);
            removeFilter(filterType);
          }}
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default DatePickerWrapper;
